
import {defineComponent} from "vue";
import {
  ProductFilterConditionRestDto,
  ProductFilterCriteriumBrandRestDto,
  ProductFilterCriteriumCategoryRestDto
} from "@/api/pharma-cpc-mgmt/models";
import {PropType} from "vue/dist/vue";
import BaseDeleteButton from "@/components/UI/Bootstrap/BaseDeleteButton.vue";
import {UIStateDto} from "@/dtos/UIStateDto";
import ProductList from "@/components/UI/product/ProductList.vue";
import {ProductListSelectionDto} from "@/components/UI/product/ProductListSelectionDto";
import {SelectionTypeEnum} from "@/api/enums/selection-type-enum";
import SelectBrands from "@/components/layouts/catalog/SelectBrands.vue";
import SelectCategories from "@/components/layouts/catalog/SelectCategories.vue";

export default defineComponent({
  name: "ProductFilterConditionBrandsCategories",
  components: {
    SelectBrands,
    SelectCategories,
    ProductList,
    BaseDeleteButton
  },
  emits: ['update:modelValue', 'filterRemoved'],
  props: {
    modelValue: {
      type: Object as PropType<ProductFilterConditionRestDto>,
      required: true
    },
    pageUI: {
      type: Object as PropType<UIStateDto>,
      required: true
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      excludedCnkCodes: [] as string[],
      excludedProductCodes: [] as string[],
      brandCodes: [] as string[],
      categoryCodes: [] as string[]
    }
  },
  mounted() {
    this.syncFromModelValue();
  },
  watch: {
    modelValue() {
      this.syncFromModelValue();
    }
  },
  methods: {
    syncFromModelValue(): void {
      this.excludedCnkCodes = [...this.modelValue.cnk_codes_excluded ?? []];
      this.excludedProductCodes = [...this.modelValue.product_codes_excluded ?? []];
      this.brandCodes = (this.modelValue.product_brand_filters ?? []).map((criterium: ProductFilterCriteriumBrandRestDto) => criterium.brand_code);
      this.categoryCodes = (this.modelValue.product_category_filters ?? []).map((criterium: ProductFilterCriteriumCategoryRestDto) => criterium.category_code);
    },
    removeCondition(): void {
      this.$emit('filterRemoved');
    },
    updateExcludedProducts(value: ProductListSelectionDto): void {
      this.excludedCnkCodes = value.cnkCodes;
      this.excludedProductCodes = value.productCodes;
      this.emitChanges();
    },
    addBrand(brandCode: string) {
      this.brandCodes.push(brandCode);
      this.emitChanges();
    },
    removeBrand(brandCode: string) {
      this.brandCodes = this.brandCodes.filter((code: string) => code !== brandCode);
      this.emitChanges();
    },
    addCategory(categoryCode: string) {
      this.categoryCodes.push(categoryCode);
      this.emitChanges();
    },
    removeCategory(categoryCode: string) {
      this.categoryCodes = this.categoryCodes.filter((code: string) => code !== categoryCode);
      this.emitChanges();
    },
    emitChanges(): void {
      this.$emit('update:modelValue', {
        ...this.modelValue,
        cnk_codes_excluded: this.excludedCnkCodes,
        product_codes_excluded: this.excludedProductCodes,
        product_brand_filters: this.brandCodes.map((code: string) => {return {selection_type_code: SelectionTypeEnum.INCLUDE, brand_code: code};}),
        product_category_filters: this.categoryCodes.map((code: string) => {return {selection_type_code: SelectionTypeEnum.INCLUDE, category_code: code};})
      });
    }
  },
  computed: {
    productSelection(): ProductListSelectionDto {
      return {
        cnkCodes: this.excludedCnkCodes,
        productCodes: this.excludedProductCodes
      };
    },
  }
});
